import { useContext } from "react";
import { ColumnDef } from "@tanstack/react-table";
import { CustomObjectGroup } from "../../../../generated/graphql";
import { AuthContext } from "../../../Authorization/AuthContext";
import Table from "../../../Common/Tables/Table";
import { ActionButton } from "./ActionButton";

const CustomObjectGroupsTable = ({
  currentData,
  previousData,
  loading,
  refetch,
}: {
  currentData?: Maybe<Array<CustomObjectGroup>>;
  previousData?: Maybe<Array<CustomObjectGroup>>;
  loading: boolean;
  refetch: () => void;
}) => {
  const { account } = useContext(AuthContext);

  const columns: Array<ColumnDef<CustomObjectGroup>> = [
    {
      id: "name",
      header: "Name",
      accessorKey: "name",
      enableSorting: false,
    },
    {
      id: "customMaps",
      header: "Object types",
      accessorKey: "customMapIds",
      enableSorting: false,
      cell: ({ row }) =>
        row.original.customMapIds
          .map(id => {
            const customMap = account?.customMaps.find(map => map.id === id);
            return customMap?.name ?? id;
          })
          .join(", "),
    },
    {
      id: "hasTable",
      header: "Table",
      accessorKey: "hasTable",
      enableSorting: false,
      cell: ({ row }) => (row.original.hasTable ? "Yes" : "No"),
    },
    {
      id: "actions",
      size: 75,
      maxSize: 75,
      enableSorting: false,
      cell: ({ row }) => (
        <ActionButton
          customObjectGroup={row.original}
          onUpdateSuccess={refetch}
          onDeleteSuccess={refetch}
        />
      ),
    },
  ];

  return (
    <Table<CustomObjectGroup>
      columns={columns}
      currentData={currentData ?? []}
      previousData={previousData ?? []}
      loadingDetails={{
        loading,
        loadingText: "Loading Account groups...",
        noDataText: "No groups",
      }}
      tableStyleDetails={{
        hasRowActions: true,
        isCompact: true,
        hasFlushedSides: true,
      }}
      excludePaginationNav
    />
  );
};

export default CustomObjectGroupsTable;
